import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) { setLoading(false); return; }
    api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    api.get("/auth/me").then((r) => {
      setUser(r.data.user); setCompany(r.data.company);
    }).catch(() => {
      localStorage.removeItem("token");
    }).finally(() => setLoading(false));
  }, []);

  const setSession = ({ token, user, company }) => {
    localStorage.setItem("token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(user); setCompany(company);
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data.mfa_required) return r.data;  // caller handles OTP
    setSession(r.data);
    return r.data;
  };

  const verifyOtp = async (email, code) => {
    const r = await api.post("/auth/superadmin/verify", { email, code });
    setSession(r.data);
    return r.data;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    setSession(r.data);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    delete api.defaults.headers.common["Authorization"];
    setUser(null); setCompany(null);
    window.location.href = "/login";
  };

  const refresh = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data.user); setCompany(r.data.company);
    return r.data;
  };

  return (
    <AuthCtx.Provider value={{ user, company, loading, login, verifyOtp, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
